import { genId } from '@/utils/id'
import { seedPoints } from '@/mock/seed'
import { filterVisible } from '@/utils/visibility'

export default {
  namespaced: true,
  state: {
    list: seedPoints
  },
  getters: {
    byTrip: state => tripId => state.list.filter(p => p.tripId === tripId),
    visibleByTrip: (state, getters) => (tripId, viewerId) => filterVisible(getters.byTrip(tripId), viewerId),
    byId: state => id => state.list.find(p => p.id === id)
  },
  mutations: {
    ADD_POINT (state, point) {
      state.list.push(point)
    },
    UPDATE_POINT (state, { id, patch }) {
      const p = state.list.find(x => x.id === id)
      if (p) Object.assign(p, patch)
    },
    REMOVE_POINT (state, id) {
      state.list = state.list.filter(p => p.id !== id)
    }
  },
  actions: {
    // 對應 4.2.3：同一個 Trip 內相同 place_id 的地點合併為一個 Point，加入收藏者清單。
    savePlace ({ commit, getters }, { tripId, place, memberId, category, planPriority }) {
      if (place.placeId) {
        const existing = getters.byTrip(tripId).find(p => p.placeId === place.placeId)
        if (existing) {
          if (!existing.savedBy.includes(memberId)) {
            commit('UPDATE_POINT', { id: existing.id, patch: { savedBy: [...existing.savedBy, memberId] } })
          }
          return existing.id
        }
      }
      const id = genId()
      commit('ADD_POINT', {
        id,
        tripId,
        placeId: place.placeId || null,
        name: place.name,
        lat: place.lat,
        lng: place.lng,
        address: place.address || '',
        category: category || place.category || 'other',
        origin: 'planned',
        status: 'planned',
        planPriority: planPriority || 'considering',
        plannedDate: null,
        wantRevisit: false,
        visitedBy: [],
        visitedAt: null,
        note: '',
        links: [],
        savedBy: [memberId],
        visibility: 'trip',
        lodging: category === 'lodging' ? { checkIn: '', checkOut: '', price: '', currency: 'JPY', roomType: '', link: '', pros: '', cons: '', bookingStatus: '未訂' } : null
      })
      return id
    },
    addDiscoveredPoint ({ commit }, { tripId, place, memberId, status }) {
      const id = genId()
      commit('ADD_POINT', {
        id,
        tripId,
        placeId: place && place.placeId ? place.placeId : null,
        name: (place && place.name) || '未命名地點',
        lat: place ? place.lat : null,
        lng: place ? place.lng : null,
        address: (place && place.address) || '',
        category: (place && place.category) || 'other',
        origin: 'discovered',
        status: status || 'visited',
        planPriority: 'confirmed',
        plannedDate: null,
        wantRevisit: status === 'missed',
        visitedBy: status === 'visited' ? [memberId] : [],
        visitedAt: status === 'visited' ? new Date().toISOString() : null,
        note: '',
        links: [],
        savedBy: [memberId],
        visibility: 'trip',
        lodging: null
      })
      return id
    },
    updateStatus ({ commit }, { id, status }) {
      const patch = { status }
      if (status === 'missed') patch.wantRevisit = true
      commit('UPDATE_POINT', { id, patch })
    },
    updatePoint ({ commit }, { id, patch }) {
      commit('UPDATE_POINT', { id, patch })
    },
    removePoint ({ commit }, id) {
      commit('REMOVE_POINT', id)
    }
  }
}
